<template>
  <div class="team-management">
    <!-- 搜索筛选区域 -->
    <el-card class="filter-container">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="活动名称">
          <el-select
              v-model="filters.activity_id"
              placeholder="请选择活动"
              clearable
              filterable
              style="width: 200px"
          >
            <el-option
                v-for="item in activityOptions"
                :key="item.id"
                :label="item.title"
                :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="团队状态">
          <el-select
              v-model="filters.status"
              placeholder="请选择状态"
              clearable
              style="width: 150px"
          >
            <el-option label="拼团中" :value="0" />
            <el-option label="拼团成功" :value="1" />
            <el-option label="拼团失败" :value="2" />
            <el-option label="已退款" :value="3" />
          </el-select>
        </el-form-item>

        <el-form-item label="关键词">
          <el-input
              v-model="filters.keyword"
              placeholder="团队编号/团长/商品名称"
              clearable
              style="width: 220px"
              @keyup.enter="handleSearch"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch" icon="el-icon-search">查询</el-button>
          <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
          <el-button type="success" @click="handleExport" icon="el-icon-download">导出</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 统计数据卡片 -->
    <el-row :gutter="20" class="statistics-cards">
      <el-col :span="6">
        <el-card class="stat-card" shadow="hover">
          <div class="stat-item">
            <div class="stat-icon blue">
              <i class="el-icon-s-grid"></i>
            </div>
            <div class="stat-info">
              <div class="stat-label">团队总数</div>
              <div class="stat-value">{{ statistics.total_teams || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card" shadow="hover">
          <div class="stat-item">
            <div class="stat-icon green">
              <i class="el-icon-success"></i>
            </div>
            <div class="stat-info">
              <div class="stat-label">成功团队</div>
              <div class="stat-value">{{ statistics.success_teams || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card" shadow="hover">
          <div class="stat-item">
            <div class="stat-icon orange">
              <i class="el-icon-data-line"></i>
            </div>
            <div class="stat-info">
              <div class="stat-label">成功率</div>
              <div class="stat-value">{{ statistics.success_rate || 0 }}%</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card" shadow="hover">
          <div class="stat-item">
            <div class="stat-icon purple">
              <i class="el-icon-time"></i>
            </div>
            <div class="stat-info">
              <div class="stat-label">进行中</div>
              <div class="stat-value">{{ ongoingCount || 0 }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 团队列表表格 -->
    <el-card class="table-container">
      <el-table
          :data="tableData"
          v-loading="loading"
          border
          stripe
          style="width: 100%"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="expand-form">
              <el-form-item label="团长头像">
                <img
                    :src="props.row.leader_avatar || defaultAvatar"
                    class="expand-avatar"
                    @error="handleImageError"
                >
              </el-form-item>
              <el-form-item label="团长昵称">
                <span>{{ props.row.leader_name }}</span>
              </el-form-item>
              <el-form-item label="商品名称">
                <span>{{ props.row.goods_title }}</span>
              </el-form-item>
              <el-form-item label="过期时间">
                <span>{{ props.row.expire_time_text }}</span>
              </el-form-item>
              <el-form-item label="成员数量">
                <span>{{ props.row.member_count }}人</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <el-table-column prop="team_no" label="团队编号" width="180" />

        <el-table-column prop="activity_title" label="活动名称" min-width="150" show-overflow-tooltip />

        <el-table-column label="团长信息" width="150">
          <template slot-scope="scope">
            <div class="leader-info">
              <img
                  :src="scope.row.leader_avatar || defaultAvatar"
                  class="leader-avatar"
                  @error="handleImageError"
              >
              <span>{{ scope.row.leader_name }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="成团进度" width="200">
          <template slot-scope="scope">
            <div class="progress-wrapper">
              <el-progress
                  :percentage="scope.row.progress"
                  :status="getProgressStatus(scope.row.status)"
                  :format="() => `${scope.row.current_size}/${scope.row.group_size}`"
              />
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="member_count" label="成员数" width="80" align="center" />

        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)" size="small">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="create_time_text" label="创建时间" width="160" />

        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <el-button
                type="primary"
                size="mini"
                icon="el-icon-view"
                @click="handleDetail(scope.row)"
            />
            <el-button
                type="success"
                size="mini"
                icon="el-icon-check"
                :disabled="scope.row.status !== 0"
                @click="handleSuccess(scope.row)"
            />
            <el-button
                type="danger"
                size="mini"
                icon="el-icon-close"
                :disabled="scope.row.status !== 0"
                @click="handleFail(scope.row)"
            />
            <el-button
                type="info"
                size="mini"
                icon="el-icon-s-order"
                @click="handleMembers(scope.row)"
            />
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          class="pagination"
      />
    </el-card>

    <!-- 团队详情对话框 -->
    <el-dialog
        title="团队详情"
        :visible.sync="detailDialog.visible"
        width="800px"
        @closed="handleDialogClosed"
    >
      <el-tabs v-model="detailDialog.activeTab">
        <el-tab-pane label="基本信息" name="info">
          <el-form label-width="100px" size="small">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="团队编号">{{ detailData.team_no }}</el-form-item>
                <el-form-item label="活动名称">{{ detailData.activity_title }}</el-form-item>
                <el-form-item label="商品名称">{{ detailData.goods_title }}</el-form-item>
                <el-form-item label="团长信息">
                  <div class="leader-detail">
                    <img :src="detailData.leader_avatar || defaultAvatar" class="detail-avatar">
                    <div>
                      <div>{{ detailData.leader_name }}</div>
                      <div>{{ detailData.leader_phone }}</div>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="成团人数">{{ detailData.group_size }}人</el-form-item>
                <el-form-item label="当前人数">{{ detailData.current_size }}人</el-form-item>
                <el-form-item label="创建时间">{{ detailData.create_time_text }}</el-form-item>
                <el-form-item label="过期时间">{{ detailData.expire_time_text }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="商品图片">
                  <div class="goods-images">
                    <el-image
                        v-for="(img, index) in detailData.goods_images"
                        :key="index"
                        :src="img"
                        :preview-src-list="detailData.goods_images"
                        class="goods-image"
                    />
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>

        <el-tab-pane label="团队成员" name="members">
          <el-table :data="detailData.members || []" border stripe size="small">
            <el-table-column prop="nickname" label="昵称" width="120" />
            <el-table-column prop="phone" label="手机号" width="120" />
            <el-table-column label="头像" width="80">
              <template slot-scope="scope">
                <img :src="scope.row.avatar || defaultAvatar" class="member-avatar">
              </template>
            </el-table-column>
            <el-table-column prop="order_no" label="订单号" min-width="180" />
            <el-table-column prop="pay_amount" label="支付金额" width="100" align="right">
              <template slot-scope="scope">¥{{ scope.row.pay_amount }}</template>
            </el-table-column>
            <el-table-column prop="create_time" label="加入时间" width="160">
              <template slot-scope="scope">{{ formatDate(scope.row.create_time) }}</template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="订单统计" name="orders">
          <el-row :gutter="20">
            <el-col :span="8" v-for="stat in detailData.order_stats" :key="stat.status">
              <el-card shadow="hover" class="stat-card-mini">
                <div class="stat-mini-label">{{ getStatusText(stat.status) }}</div>
                <div class="stat-mini-count">{{ stat.count }}单</div>
                <div class="stat-mini-amount">¥{{ stat.amount || 0 }}</div>
              </el-card>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>

      <span slot="footer">
        <el-button @click="detailDialog.visible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 手动解散对话框 -->
    <el-dialog
        title="手动解散团队"
        :visible.sync="failDialog.visible"
        width="400px"
    >
      <el-form :model="failDialog.form" :rules="failDialog.rules" ref="failForm">
        <el-form-item label="解散原因" prop="reason">
          <el-input
              type="textarea"
              v-model="failDialog.form.reason"
              :rows="3"
              placeholder="请输入解散原因"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="failDialog.visible = false">取消</el-button>
        <el-button type="danger" @click="submitFail">确认解散</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { getTeamList, getTeamDetail, manualSuccess, manualFail, exportTeams, getStatistics } from '@/api/team'
// import { formatDate } from '@/utils/date'

export default {
  name: 'teamList',
  data() {
    return {
      loading: false,
      defaultAvatar: require('@/assets/images/logo-mini.png'),
      filters: {
        activity_id: '',
        status: '',
        keyword: '',
        start_date: '',
        end_date: ''
      },
      activityOptions: [],
      tableData: [],
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      statistics: {},
      ongoingCount: 0,
      detailDialog: {
        visible: false,
        activeTab: 'info'
      },
      detailData: {},
      failDialog: {
        visible: false,
        form: {
          reason: ''
        },
        rules: {
          reason: [
            { required: true, message: '请输入解散原因', trigger: 'blur' },
            { min: 5, message: '至少输入5个字符', trigger: 'blur' }
          ]
        },
        currentTeam: null
      }
    }
  },
  created() {
    this.fetchActivityOptions()
    this.fetchList()
    this.fetchStatistics()
  },
  methods: {
    formatDate(val,fmt){
      console.log(val)
      console.log(fmt)
    },

    // 获取活动选项
    async fetchActivityOptions() {
      try {
        const res = await this.$axios.getActivityList({ pageSize: 1000 })
        if (res.code === 200) {
          this.activityOptions = res.data.list
        }
      } catch (error) {
        console.error('获取活动列表失败:', error)
      }
    },

    // 获取团队列表
    async fetchList() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
          ...this.filters
        }
        const res = await this.$axios.getTeamList(params)
        if (res.code === 200) {
          this.tableData = res.data.list
          this.pagination.total = res.data.total
        }
      } catch (error) {
        this.$message.error('获取列表失败')
      } finally {
        this.loading = false
      }
    },

    // 获取统计数据
    async fetchStatistics() {
      try {
        const res = await this.$axios.getStatistics(this.filters)
        if (res.code === 200) {
          this.statistics = res.data
          // 计算进行中的团队数量
          const ongoing = this.statistics.status_stats?.find(s => s.status === 0)
          this.ongoingCount = ongoing ? ongoing.count : 0
        }
      } catch (error) {
        console.error('获取统计数据失败:', error)
      }
    },



    // 搜索
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
      this.fetchStatistics()
    },

    // 重置筛选
    handleReset() {
      this.filters = {
        activity_id: '',
        status: '',
        keyword: '',
        start_date: '',
        end_date: ''
      }
      this.pagination.page = 1
      this.fetchList()
      this.fetchStatistics()
    },

    // 导出数据
    handleExport() {
      this.$confirm('确定导出当前筛选条件下的团队数据吗？', '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          const res = await this.$axios.exportTeams(this.filters)
          // 处理文件下载
          const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `拼团团队数据_${this.formatDate(Date.now(), 'YYYYMMDDHHmmss')}.xlsx`
          link.click()
          URL.revokeObjectURL(link.href)
          this.$message.success('导出成功')
        } catch (error) {
          this.$message.error('导出失败')
        }
      })
    },

    // 查看详情
    async handleDetail(row) {
      try {
        const res = await this.$axios.getTeamDetail(row.id)
        if (res.code === 200) {
          this.detailData = res.data
          this.detailDialog.visible = true
        }
      } catch (error) {
        this.$message.error('获取详情失败')
      }
    },

    // 手动成功
    handleSuccess(row) {
      this.$confirm(`确定手动将团队 "${row.team_no}" 设置为拼团成功吗？`, '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          const res = await this.$axios.manualSuccess(row.id)
          if (res.code === 200) {
            this.$message.success('操作成功')
            this.fetchList()
            this.fetchStatistics()
          }
        } catch (error) {
          this.$message.error('操作失败')
        }
      })
    },

    // 手动解散
    handleFail(row) {
      this.failDialog.currentTeam = row
      this.failDialog.form.reason = ''
      this.failDialog.visible = true
    },

    // 提交解散
    async submitFail() {
      this.$refs.failForm.validate(async (valid) => {
        if (valid) {
          try {
            const res = await this.$axios.manualFail(this.failDialog.currentTeam.id, {
              reason: this.failDialog.form.reason
            })
            if (res.code === 200) {
              this.$message.success('解散成功')
              this.failDialog.visible = false
              this.fetchList()
              this.fetchStatistics()
            }
          } catch (error) {
            this.$message.error('解散失败')
          }
        }
      })
    },

    // 查看成员
    handleMembers(row) {
      this.handleDetail(row)
      this.detailDialog.activeTab = 'members'
    },

    // 分页
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.page = 1
      this.fetchList()
    },

    handleCurrentChange(val) {
      this.pagination.page = val
      this.fetchList()
    },

    // 对话框关闭回调
    handleDialogClosed() {
      this.detailData = {}
      this.detailDialog.activeTab = 'info'
    },

    // 获取状态类型
    getStatusType(status) {
      const map = {
        0: 'warning',
        1: 'success',
        2: 'danger',
        3: 'info'
      }
      return map[status] || 'info'
    },

    // 获取状态文本
    getStatusText(status) {
      const map = {
        0: '拼团中',
        1: '拼团成功',
        2: '拼团失败',
        3: '已退款'
      }
      return map[status] || '未知'
    },

    // 获取进度条状态
    getProgressStatus(status) {
      if (status === 1) return 'success'
      if (status === 2 || status === 3) return 'exception'
      return ''
    },

    // 处理图片加载失败
    handleImageError(e) {
      e.target.src = this.defaultAvatar
    }
  }
}
</script>

<style lang="scss" scoped>
.team-management {
  padding: 20px;

  .filter-container {
    margin-bottom: 20px;
  }

  .statistics-cards {
    margin-bottom: 20px;

    .stat-card {
      .stat-item {
        display: flex;
        align-items: center;

        .stat-icon {
          width: 60px;
          height: 60px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 15px;

          i {
            font-size: 30px;
            color: #fff;
          }

          &.blue { background: linear-gradient(135deg, #409EFF, #36a2f0); }
          &.green { background: linear-gradient(135deg, #67C23A, #5cb32e); }
          &.orange { background: linear-gradient(135deg, #E6A23C, #d48a1f); }
          &.purple { background: linear-gradient(135deg, #9C27B0, #7b1fa2); }
        }

        .stat-info {
          flex: 1;

          .stat-label {
            color: #909399;
            font-size: 14px;
            margin-bottom: 5px;
          }

          .stat-value {
            color: #303133;
            font-size: 24px;
            font-weight: bold;
          }
        }
      }
    }
  }

  .table-container {
    .leader-info {
      display: flex;
      align-items: center;

      .leader-avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 8px;
        object-fit: cover;
      }
    }

    .progress-wrapper {
      padding: 0 10px;
    }

    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }

  .expand-form {
    padding: 20px;

    .expand-avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  .leader-detail {
    display: flex;
    align-items: center;

    .detail-avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      margin-right: 10px;
      object-fit: cover;
    }
  }

  .goods-images {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .goods-image {
      width: 100px;
      height: 100px;
      border-radius: 4px;
      object-fit: cover;
      cursor: pointer;
    }
  }

  .member-avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    object-fit: cover;
  }

  .stat-card-mini {
    text-align: center;

    .stat-mini-label {
      color: #909399;
      font-size: 14px;
      margin-bottom: 10px;
    }

    .stat-mini-count {
      font-size: 24px;
      font-weight: bold;
      color: #303133;
      margin-bottom: 5px;
    }

    .stat-mini-amount {
      color: #F56C6C;
      font-size: 16px;
    }
  }
}
</style>